// extracted by mini-css-extract-plugin
export default {"infoBox":"PricingStep_infoBox__kixtm","infoBoxIcon":"PricingStep_infoBoxIcon__LbRla","infoBoxText":"PricingStep_infoBoxText__siM48"};